import firebase from "config/firebase";
import moment from "moment";

export const getAthletes = () => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("users")
      .where("role", "==", "athlete")
      .onSnapshot((query) => {
        var athletes = [];
        query.forEach((doc) => {
          athletes.push({ id: doc.id, ...doc.data() });
        });
        dispatch({
          type: "GET_ATHLETES",
          payload: athletes,
        });
      });
  };
};

export const getAthlete = () => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("users")
      .where("role", "==", "athlete")
      .onSnapshot((query) => {
        var athlete = [];
        for (let doc of query.docs) {
          let { created_at } = doc.data();
          let currYear = moment.unix(created_at.seconds).format("Y");
          let index = athlete.findIndex((history) => history.year == currYear);
          if (index != -1) {
            athlete[index] = {
              year: currYear,
              athleteReg: [
                ...athlete[index].athleteReg,
                {
                  id: doc.id,
                  ...doc.data(),
                },
              ],
            };
          } else {
            athlete.push({
              year: currYear,
              athleteReg: [
                {
                  id: doc.id,
                  ...doc.data(),
                },
              ],
            });
          }
        }
        dispatch({
          type: "GET_ATHLETE_CALCULATE",
          payload: athlete,
        });
      });
  };
};

export const getRegistrationTotal = (year) => {
  return async (dispatch) => {
    const startTimestamp = new Date(parseInt(year), 0, 1).getTime() / 1000;
    const endTimestamp = new Date(parseInt(year) + 1, 0, 1).getTime() / 1000;
    firebase
      .firestore()
      .collection("users")
      .where("role", "==", "athlete")
      .onSnapshot((query) => {
        var registrationTotal = 0;
        query.forEach((doc) => {
          if (
            doc.data().created_at.seconds >= startTimestamp &&
            doc.data().created_at.seconds < endTimestamp
          ) {
            registrationTotal = registrationTotal + 1;
          }
        });
        registrationTotal = registrationTotal * 2;
        dispatch({
          type: "GET_REGISTRATION_TOTAL",
          payload: registrationTotal,
        });
      });
  };
};
export const getFanRegistrationTotal = (year) => {
  return async (dispatch) => {
    const startTimestamp = new Date(parseInt(year), 0, 1).getTime() / 1000;
    const endTimestamp = new Date(parseInt(year) + 1, 0, 1).getTime() / 1000;
    firebase
      .firestore()
      .collection("users")
      .where("role", "==", "fan")
      .onSnapshot((query) => {
        var registrationTotal = 0;
        query.forEach((doc) => {
          if (doc.data()?.created_at) {
            if (
              doc.data().created_at.seconds >= startTimestamp &&
              doc.data().created_at.seconds < endTimestamp
            ) {
              registrationTotal = registrationTotal + 1;
            }
          } else {
            console.log("no have Date", doc.data());
          }
        });
        dispatch({
          type: "GET_FAN_REGISTRATION_TOTAL",
          payload: registrationTotal,
        });
      });
  };
};

export const getChatTotalAmount = (year) => {
  return async (dispatch) => {
    const startTimestamp = new Date(parseInt(year), 0, 1).getTime() / 1000;
    const endTimestamp = new Date(parseInt(year) + 1, 0, 1).getTime() / 1000;
    firebase
      .firestore()
      .collection("new_a4b_chat")
      .where("type", "==", "appointment")
      .onSnapshot((query) => {
        var chatTotal = 0;
        query.forEach((doc) => {
          if (
            doc.data().created_at?.seconds >= startTimestamp &&
            doc.data().created_at?.seconds < endTimestamp
          ) {
            if (doc.data().athlete_payout) {
              let amount = parseFloat(doc.data().paid_amount.value) - 0.5;
              chatTotal += (amount / 100) * 12;
            }
          }
        });
        dispatch({
          type: "GET_CHAT_TOTAL_AMOUNT",
          payload: chatTotal,
        });
      });
  };
};
export const getGroupChatTotalAmount = (year) => {
  return async (dispatch) => {
    const startTimestamp = new Date(parseInt(year), 0, 1).getTime() / 1000;
    const endTimestamp = new Date(parseInt(year) + 1, 0, 1).getTime() / 1000;
    firebase
      .firestore()
      .collection("new_a4b_chat")
      .where("type", "==", "group")
      .onSnapshot((query) => {
        var chatTotal = 0;
        query.forEach((doc) => {
          if (
            doc.data().created_at?.seconds >= startTimestamp &&
            doc.data().created_at?.seconds < endTimestamp
          ) {
            if (doc.data().athlete_payout) {
              let amount = parseFloat(doc.data().paid_amount.value) - 0.5;
              chatTotal += (amount / 100) * 12;
            }
          }
        });
        dispatch({
          type: "GET_GROUP_CHAT_TOTAL_AMOUNT",
          payload: chatTotal,
        });
      });
  };
};

export const getLicenseTotalAmount = (year) => {
  return async (dispatch) => {
    const startTimestamp = new Date(parseInt(year), 0, 1).getTime() / 1000;
    const endTimestamp = new Date(parseInt(year) + 1, 0, 1).getTime() / 1000;
    firebase
      .firestore()
      .collection("license_purchases")
      .onSnapshot((query) => {
        var licenseTotal = 0;
        query.forEach((doc) => {
          if (
            doc.data().created_at.seconds >= startTimestamp &&
            doc.data().created_at.seconds < endTimestamp
          ) {
            licenseTotal = licenseTotal + parseFloat(doc.data().amount.value);
          }
        });
        firebase
          .firestore()
          .collection("license_subscriptions")
          .onSnapshot((query1) => {
            query1.forEach((doc) => {
              if (
                doc.data().created_at.seconds >= startTimestamp &&
                doc.data().created_at.seconds < endTimestamp &&
                doc.data().status == "active"
              ) {
                licenseTotal = licenseTotal + parseInt(doc.data().amount.value);
              }
            });
          });
        dispatch({
          type: "GET_LICENSE_TOTAL_AMOUNT",
          payload: licenseTotal / 2,
        });
      });
  };
};

export const getOrderTotalAmount = (year) => {
  return async (dispatch) => {
    const startTimestamp = new Date(parseInt(year), 0, 1).getTime() / 1000;
    const endTimestamp = new Date(parseInt(year) + 1, 0, 1).getTime() / 1000;
    firebase
      .firestore()
      .collection("orders")
      .onSnapshot((query) => {
        var orderTotal = 0;
        query.forEach((doc) => {
          if (
            doc.data().created_at.seconds >= startTimestamp &&
            doc.data().created_at.seconds < endTimestamp
          ) {
            let amount = parseFloat(doc.data().amount.value) - 1.99;
            orderTotal += amount;
          }
        });
        dispatch({
          type: "GET_ORDER_TOTAL_AMOUNT",
          payload: orderTotal,
        });
      });
  };
};
export const getAthleteDataById = (
  id,
  contestId = "",
  onSuccess = () => {}
) => {
  return async (dispatch) => {
    try {
      let isSuggested = false;
      if (contestId) {
        const contestSnapshot = await firebase
          .firestore()
          .collection("contest_athletes")
          .where("contestId", "==", contestId)
          .where("athleteID", "==", id)
          .get();

        if (!contestSnapshot.empty) {
          isSuggested = contestSnapshot.docs[0].data().isSuggested;
        }
      }

      const querySnapshot = await firebase
        .firestore()
        .collection("users")
        .where("athleteID", "==", id)
        .get();

      const userData = [];
      querySnapshot.forEach((doc) => {
        userData.push({ id: doc.id, ...doc.data() });
      });

      dispatch({ type: "ATHLETE_DATA_RECEIVED", payload: userData[0] });
      onSuccess(userData[0], isSuggested);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
};
